import styled from 'helpers/styles';
import PropTypes from 'prop-types';
import ComponentStyles from 'styles/mixins/Component.styles';
import BaseTableCell from 'components/molecules/TableCells/BaseTableCell/BaseTableCell';

const StyledIconButtonTableCell = styled(BaseTableCell)`
  ${ComponentStyles}
`;

StyledIconButtonTableCell.propTypes = {
  theme: PropTypes.object
};

export default StyledIconButtonTableCell;
